'use strict';

var internals = {};

module.exports = function () {
  try {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return JSON.stringify.apply(null, args);
  } catch (err) {
    return '[Cannot display object: ' + err.message + ']';
  }
};